// A document viewer's own close, told apart from the other things that fire
// `closeDocumentPanel` (#12452).
//
// The event takes panes down: the split pane, the drawer's artifact, an
// artifact's version history. Since a document can show beside the artifact
// it was cited from, the document closing must not take the artifact or its
// history with it, so the file viewer marks its close and names the artifact
// it was showing, if any.
const CLOSE_DOCUMENT_PANEL_EVENT = "closeDocumentPanel";

export interface DocumentCloseDetail {
  document: true;
  /** The artifact the closing viewer showed, when it showed one's file. */
  artifactId: string | null;
}

export const dispatchDocumentClose = (artifactId: string | null): void => {
  const detail: DocumentCloseDetail = { document: true, artifactId };
  window.dispatchEvent(new CustomEvent(CLOSE_DOCUMENT_PANEL_EVENT, { detail }));
};

/** The detail of a document viewer's own close, or null for any other
 *  event, including a `closeDocumentPanel` from another source. */
export const documentCloseDetail = (
  event: Event
): DocumentCloseDetail | null => {
  if (event.type !== CLOSE_DOCUMENT_PANEL_EVENT) return null;
  const detail = (event as CustomEvent<DocumentCloseDetail | null>).detail;
  return detail?.document === true ? detail : null;
};
